import React, { useEffect, useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  Stack,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { flows } from '../../services/api';

interface DailyStats {
  streak_days: number;
  total_completions: number;
}

const DailyCheckinComplete: React.FC = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState<DailyStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      setError(null);
      const response = await flows.getFlowStats('daily_checkin_v0');
      setStats(response.data);
    } catch (error) {
      console.error('Error loading stats:', error);
      setError('Failed to load your daily check-in stats. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container maxWidth="md">
        <Typography>Loading...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom color="primary">
          🎉 Congratulations!
        </Typography>
        
        <Typography variant="h5" gutterBottom>
          You've completed today's check-in
        </Typography>

        {stats && (
          <Box sx={{ mt: 2, mb: 4 }}>
            <Typography variant="h6" color="text.secondary">
              Current Streak: {stats.streak_days} {stats.streak_days === 1 ? 'day' : 'days'}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
              Total Check-ins Completed: {stats.total_completions}
            </Typography>
          </Box>
        )}

        <Stack spacing={2} sx={{ mt: 4 }}>
          <Button
            variant="outlined"
            onClick={() => navigate('/daily-checkin-customization')}
            fullWidth
          >
            Customize Your Daily Questions
          </Button>
          
          <Button
            variant="contained"
            onClick={() => navigate('/')}
            fullWidth
          >
            Return Home
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
};

export default DailyCheckinComplete;
